import { Divider } from "@mui/material";
import React from "react";

export default function CenteredDivider() {
  return <Divider style={{ width: "90%", margin: "auto" }} />;
}
